import { post, fetch, patch, put } from '@/utils/http';
const API_ROOT = process.env.VUE_APP_API_URL;

/**
 * 获取我的登记信息
 */
async function getMyProfile() {
    return fetch(`${API_ROOT}/alumni/getMyProfile`);
}

/**
 * 保存我的校友信息
 */
async function saveMyProfile(data) {
    return post(`${API_ROOT}/alumni/saveMyProfile`, data);
}

export {
    getMyProfile,
    saveMyProfile,
}
